import { render, staticRenderFns } from "./MarketShow2.vue?vue&type=template&id=4f5f89d4&scoped=true&"
import script from "./MarketShow2.vue?vue&type=script&lang=js&"
export * from "./MarketShow2.vue?vue&type=script&lang=js&"
import style0 from "./MarketShow2.vue?vue&type=style&index=0&id=4f5f89d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f89d4",
  null
  
)

export default component.exports